import * as React from 'react';
import { Input } from 'ouisys-component-library';
import { InputType } from 'ouisys-component-library';
import { FormattedMessage } from '../../../localization';

import defaultMessages from '../utils/defaultMessages';

interface FormInputProps {
  classNames?: string;
  name: string;
  type?: string;
  onBlur?: any;
  onChange?: any;
  onClick?: any;
  onPaste?: any;
  required?: boolean;
  formData: Object;
  intl: any;
  labelId?: string;
  autoComplete?: string;
}

const FormInput = ({
  classNames,
  name,
  type,
  intl,
  formData,
  onBlur,
  onChange,
  onClick,
  onPaste,
  required = true,
  labelId,
  autoComplete
}: FormInputProps) => {
  return (
    <div className="form-group">
      <label className="form-label">
        <FormattedMessage id={labelId || name} defaultMessage={intl.formatMessage(defaultMessages[name])} />
      </label>
      <Input
        id={defaultMessages[name].id}
        name={name}
        className={`form-control ${classNames || ''}`}
        placeholder={intl.formatMessage(defaultMessages[name])}
        value={formData[name].value}
        onBlur={onBlur}
        onChange={onChange}
        onClick={onClick}
        type={type || InputType[name]}
        error={
          !formData[name].valid &&
          intl.formatMessage(defaultMessages[name]) + ' ' + intl.formatMessage(defaultMessages.required)
        }
        onPaste={onPaste}
        required={required}
        autoComplete={autoComplete}
      />
    </div>
  );
};

export default FormInput;
